/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-02-10 10:23:17
 * @LastEditors: sj
 * @LastEditTime: 2022-02-10 17:06:18
 */
export interface CellParams {
  name?: string
  moneySum?: number
  drugMoneySum?: number
}

// 获取性别
export const getSexName = (type: number) => {
  switch (type) {
    case 0:
      return '女'
    case 1:
      return '男'
    default:
      return '未知'
  }
}

// 详情头部类型
export interface headerDataType {
  orderNum: number
  uploadTime: string
  hospitalName: string
  recipientName: string
  sex: string
  age: number
  recipientPhone: string
  addressType: string
  boilTypeName: string
  province: string
}
